export const flowComplainZH = {
  flowComplain1: '投诉',
  flowComplain2: '建议',
  flowComplain3: '商务合作',
  flowComplain4: '商务合作、问题反馈请联系我们，我们会在收到邮件后及时反馈哦',
  flowComplain5: '用户反馈',
  flowComplain6: '请输入您的姓名',
  flowComplain7: '您的联系方式，QQ/手机/邮箱',
  flowComplain8: '留下您的意见或建议吧',
  flowComplain9: '提交',
  flowComplain10: 'Bloom答疑',
  flowComplain11: '操作遇到问题欢迎咨询答疑老师，您也可以关注WeBloom微信公众号，在公众号中留言咨询',
  flowComplain12: '李老师',
  flowComplain13: '请填写意见或建议后提交',
  flowComplain14: '请填写联系方式后提交',
  flowComplain15: '提交成功，感谢您的反馈！',
  flowComplain16: '联系我们',
  flowComplain17: '请输入您的联系方式，QQ/手机/邮箱',
  flowComplain18: '操作遇到问题欢迎咨询答疑老师，或者关注WeBloom微信公众号'
}

export const flowComplainEN = {
  flowComplain1: 'Complaints',
  flowComplain2: ' Suggestions',
  flowComplain3: 'Business Cooperation',
  flowComplain4: 'Please contact us for business co-operation and feedback, we will give you prompt feedback after receiving the email.',
  flowComplain5: 'User Feedback',
  flowComplain6: 'Please enter your name',
  flowComplain7: 'Your contact information, QQ/mobile phone/email',
  flowComplain8: 'Write down your comments or suggestions',
  flowComplain9: 'Submit',
  flowComplain10: 'Bloom Q&A',
  flowComplain11: 'If you encounter any problems in the operation, you are welcome to consult the Q&A teacher, or you can follow the WeBloom WeChat Official Accounts and leave a message in the official accounts',
  flowComplain12: 'Mr. Li',
  flowComplain13: 'Please fill in your comments or suggestions and submit',
  flowComplain14: 'Please fill in the contact information and submit',
  flowComplain15: 'Successfully submitted, thanks for your feedback!',
  flowComplain16: 'Contact Us',
  flowComplain17: 'Please enter Your contact information, QQ/mobile phone/email',
  flowComplain18: 'Operation problems encountered welcome to consult the Q&A teacher, or follow WeBloom WeChat Official Accounts'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/complain.js